module.exports = __webpack_public_path__ + "static/img/slide_5_en.c6597a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_5_en.svg
// module id = Aozc
// module chunks = 0